<script setup lang="ts">
import { nextTick, onMounted } from 'vue'
import useEnquiryMultiStep from '~/components/pages/Enquiry/MultiStepsForm/Composables/useEnquiryMultiStep'
import EnquiryCaptureMobile from '~/components/pages/Enquiry/MultiStepsForm/Sections/EnquiryCaptureMobile.vue'
import { checkExpiredLocalStorage, getDataEnquiry } from '~/helper/enquiry'
import { useEnquiryCaptureStore } from '~/store/pinia/enquiryCapture'

defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
})
defineEmits(['close'])

const enquiryCaptureStore = useEnquiryCaptureStore()
const { apiLoaded, getDetailProfile, fetchDataEnquiryOption, setRecaptcha } = useEnquiryMultiStep()
const { isMobile } = useDevice()

onMounted(async () => {
  await nextTick()
  checkExpiredLocalStorage()
  const enquiryMultiInfo = getDataEnquiry()
  enquiryCaptureStore.setStepsData(enquiryMultiInfo || null)
  const arr = [getDetailProfile(), setRecaptcha()]
  if (isMobile) {
    arr.push(fetchDataEnquiryOption())
  }
  Promise.allSettled(arr)
})
</script>

<template>
  <div v-if="apiLoaded">
    <EnquiryCaptureMobile v-if="isMobile" :visible="visible" @close="$emit('close')" />
  </div>
</template>

<style scoped lang="scss"></style>
